import React, { useEffect, useRef, useState } from "react";
import { getSmoothStepPath, Position,EdgeProps } from "reactflow";

const LANE_GAP = 50;
const BASE_LANE_OFFSET = 200;
/* ----------------------------------
   Component
---------------------------------- */

const ReturnEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
}) => {
  const { lane = 0, onEdit } = data;

  const laneOffset = BASE_LANE_OFFSET + lane * LANE_GAP;

  /* ---------- BUILD EDGE PATH ---------- */
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    offset: laneOffset,
    borderRadius: 18,
  });

  /* ---------- REAL PATH CENTER ---------- */
  const pathRef = useRef<SVGPathElement | null>(null);
  const [center, setCenter] = useState<{ x: number; y: number } | null>(null);

  useEffect(() => {
    if (!pathRef.current) return;

    const totalLength = pathRef.current.getTotalLength();
    const midPoint = pathRef.current.getPointAtLength(
      totalLength / 2
    );

    setCenter({ x: midPoint.x, y: midPoint.y });
  }, [edgePath]);

  return (
    <>
      {/* ---------- ARROW MARKER ---------- */}
      <defs>
        <marker
          id={`return-arrow-${id}`}
          markerWidth="6"
          markerHeight="6"
          viewBox="0 0 8 8"
          refX="7"
          refY="4"
          orient="auto"
          markerUnits="strokeWidth"
        >
          <path d="M 0 0 L 8 4 L 0 8 z" fill="#dc3545" />
        </marker>
      </defs>

      {/* ---------- RETURN PATH ---------- */}
      <path
        ref={pathRef}
        d={edgePath}
        fill="none"
        stroke="#dc3545"
        strokeWidth={2}
        strokeDasharray="6 4"
        markerEnd={`url(#return-arrow-${id})`}
      >
        <animate
          attributeName="stroke-dashoffset"
          from="0"
          to="-20"
          dur="1s"
          repeatCount="indefinite"
        />
      </path>

      {/* ---------- CENTERED RETURN BUTTON ---------- */}
      {center && (
        <foreignObject
          x={center.x - 14}
          y={center.y - 14}
          width={28}
          height={28}
          style={{ pointerEvents: "none" }}
        >
          <div
            style={{
              pointerEvents: "all",
              width: 28,
              height: 28,
              borderRadius: "50%",
              background: "#dc3545",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
            }}
            title="Configure Return"
            onClick={(e: React.MouseEvent<HTMLDivElement>) => {
              e.stopPropagation();
              e.preventDefault();

              onEdit(id, {
                type: "return",
                fromStageId: data.fromStageId,
                toStageId: data.toStageId,
                x: e.clientX,
                y: e.clientY,
              });
            }}
          >
            <i
              className="ri-arrow-go-back-line"
              style={{
                fontSize: 14,
                color: "#fff",
                pointerEvents: "none",
              }}
            />
          </div>
        </foreignObject>
      )}
    </>
  );
};

export default ReturnEdge;
